import colors from 'styles/theme/colors';

export default function SavedIcon({
  width = 12,
  height = 12,
  color = colors.green100,
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <circle cx='6' cy='6' r='6' fill={color} />
      <path
        d='M8.20089 3.88918L5.04794 7.04214L3.89908 5.89328C3.80459 5.80202 3.67803 5.75152 3.54666 5.75266C3.41529 5.7538 3.28963 5.80649 3.19673 5.89939C3.10384 5.99228 3.05115 6.11794 3.05001 6.24931C3.04887 6.38068 3.09937 6.50724 3.19063 6.60173L4.69371 8.10481C4.78767 8.19874 4.91508 8.25151 5.04794 8.25151C5.18079 8.25151 5.3082 8.19874 5.40216 8.10481L8.90934 4.59763C9.00061 4.50314 9.05111 4.37658 9.04997 4.24521C9.04883 4.11384 8.99613 3.98818 8.90324 3.89528C8.81035 3.80239 8.68468 3.7497 8.55331 3.74855C8.42195 3.74741 8.29539 3.79791 8.20089 3.88918Z'
        fill='white'
      />
    </svg>
  );
}
